import { Component, OnInit,Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormatterService } from 'src/app/utils/formatter/formatter.service';
import { CategoriaService } from '../categoria.service';

@Component({
  selector: 'app-categoria-view',
  templateUrl: './categoria-view.component.html',
  styleUrls: ['./categoria-view.component.scss']
})
export class CategoriaViewComponent implements OnInit {
  form: FormGroup = new FormGroup({});
  @Input() element: any = {}
  constructor(
    public formBuilder: FormBuilder,
    public activeModal: NgbActiveModal,
    public formatter: FormatterService,
    public service: CategoriaService
  ) { }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      id:[],
      nombre: ['', [Validators.required]],
      descripcion: ['',],
      estado: ['', [Validators.required]],
      categoria_padre: [],
    });
    this.element.categoria_padre= this.element.categoria_padre?.nombre;
    this.form.patchValue(this.element);
    this.form.disable();
  }
}
